// @flow

import { getConfiguratorSettings } from './main';

import type { State } from '../reducers';

type GlobalState = {
  configuratorSettings: State,
};

type ConfigChoiceButton = $PropertyType<State, 'collapsible_config_choice_button'>;

type CollapsedButtonText = $PropertyType<ConfigChoiceButton, 'collapsed'>;
export const getConfigChoiceCollapsedButtonText = (state: GlobalState): CollapsedButtonText => (
  getConfiguratorSettings(state).collapsible_config_choice_button.collapsed
);

type ExpandedButtonText = $PropertyType<ConfigChoiceButton, 'expanded'>;
export const getConfigChoiceExpandedButtonText = (state: GlobalState): ExpandedButtonText => (
  getConfiguratorSettings(state).collapsible_config_choice_button.expanded
);

export default null;
